module.exports = __webpack_public_path__ + "img/logo-wdc.220a826c.svg";